module.exports = __webpack_public_path__ + "fonts/Simple-Line-Icons.b2892aa6.ttf";